import type { FC, ReactNode } from 'react';
import { Grid } from '@material-ui/core';

const PanelHeader: FC<ReactNode> = ({ children }) => (
  <Grid container justifyContent="space-between" spacing={3}>
    {children}
  </Grid>
);

export default PanelHeader;
